import { AST, parse } from '@handlebars/parser';

export const getStatements = (content: string): AST.Statement[] | null => {
  try {
    // Return the first statement in the parsed content, if available
    return parse(content).body;
  } catch {
    return null;
  }
};
